import "./PasswordInputComponent.scss";
import InputComponent from "../input/InputComponent";
import React, {useCallback, useState} from "react";
import {IPasswordFieldProps} from "../../../models/form-controls.model";
import ButtonComponent from "../button/ButtonComponent";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

export interface PasswordInputComponentProps extends IPasswordFieldProps {
    name: string;
    canToggle?: boolean;
    value?: string;
    errorMessage?: any;
    hasError?: boolean;
}

const PasswordInputComponent = (props: PasswordInputComponentProps) => {

    const {
        canToggle,
        ...otherProps
    } = props;

    const [inputType, setInputType] = useState<"password" | "text">("password");

    const handleClickShowPassword = useCallback(() => {
        setInputType(inputType === "password" ? "text" : "password");
    }, [inputType]);

    return (
        <InputComponent
            type={inputType}
            suffix={
                (canToggle) &&
                <ButtonComponent variant={"icon"}
                                 color={"inherit"}
                                 handleClick={handleClickShowPassword}>
                    {inputType === "text" ? <VisibilityOff/> : <Visibility/>}
                </ButtonComponent>
            }
            dataTestId="password-input"
            {...otherProps}
        />
    );

}

export default PasswordInputComponent;
